import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, unref as _unref, vShow as _vShow, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "jumbotron" }
const _hoisted_3 = { class: "display-4" }
const _hoisted_4 = { class: "lead" }
const _hoisted_5 = { class: "form-check form-check-inline" }
const _hoisted_6 = ["id", "value"]
const _hoisted_7 = ["for"]
const _hoisted_8 = ["href", "disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  class: "alert alert-primary mt-5",
  role: "alert"
}
const _hoisted_11 = ["href"]

import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from 'vue-router'
    import { useShareNotificationPage } from '@DataSharing/Shares/pages-core'
    import ValidationError from "@common/Components/ValidationError.vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ShareNotificationPage',
  setup(__props) {

    document.title = 'Share data'

    const route = useRoute()
    const shareId = route.params.shareId

    const selectedEmails = ref([])
    const message = ref('')

    const organizationName = computed(() => modelShareNotificationQueryV1.value?.OrganizationUnitName)
    const workspaceName = computed(() => modelShareNotificationQueryV1.value?.WorkspaceName)
    const projectName = computed(() => modelShareNotificationQueryV1.value?.ProjectName)
    const resourceName = computed(() => modelShareNotificationQueryV1.value?.ResourceName)
    const resourceUrl = computed(() => modelShareNotificationQueryV1.value?.ResourceUrl)
    const resourceProviderName = computed(() => modelShareNotificationQueryV1.value?.ResourceProviderName)
    const resourceId = computed(() => modelShareNotificationQueryV1.value?.ResourceId)
    const emails = computed(() => modelShareNotificationQueryV1.value?.Emails || [])

    const { useShareNotificationQuery, useSendNotificationCommand } = useShareNotificationPage()

    const { modelShareNotificationQueryV1, runShareNotificationQueryV1, succeed } = useShareNotificationQuery(shareId)

    const { invokeSendNotificationCommandV1, succeedSendNotificationCommandV1, invokingSendNotificationCommandV1 } = useSendNotificationCommand(shareId, message, selectedEmails)

    onMounted(() => runShareNotificationQueryV1())

    watch(succeed, () => {
        if (emails.value.length == 0) {
            navigateToResourceSharePage()
        }
    })

    function navigateToResourceSharePage() {
        location.href = `/#/sharing/resource/${resourceProviderName.value}/${resourceId.value}`
    }

return (_ctx: any,_cache: any) => {
  return (emails.value.length>0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1 /* CACHED */)),
        _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, "Sharing " + _toDisplayString(resourceName.value), 1 /* TEXT */),
          _createElementVNode("p", _hoisted_4, [
            _cache[3] || (_cache[3] = _createTextVNode("Send notification for shared ", -1 /* CACHED */)),
            _createElementVNode("strong", null, _toDisplayString(resourceName.value), 1 /* TEXT */),
            _cache[4] || (_cache[4] = _createTextVNode(" owned by ", -1 /* CACHED */)),
            _createElementVNode("strong", null, _toDisplayString(organizationName.value), 1 /* TEXT */),
            _cache[5] || (_cache[5] = _createTextVNode(" data in TransparentChoice application", -1 /* CACHED */))
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(emails.value, (e) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedEmails).value = $event)),
                class: "form-check-input",
                type: "checkbox",
                id: `email_${e}`,
                value: e
              }, null, 8 /* PROPS */, _hoisted_6), [
                [_vModelCheckbox, selectedEmails.value]
              ]),
              _createElementVNode("label", {
                class: "form-check-label",
                for: `email_${e}`
              }, _toDisplayString(e), 9 /* TEXT, PROPS */, _hoisted_7)
            ]))
          }), 256 /* UNKEYED_FRAGMENT */)),
          _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((message).value = $event)),
            class: "form-control",
            placeholder: "Optianal message here"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, message.value]
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/sharing/resource/${resourceProviderName.value}/${resourceId.value}`,
            class: "btn btn-lg btn-secondary m-1",
            disabled: _unref(invokingSendNotificationCommandV1)
          }, "Skip", 8 /* PROPS */, _hoisted_8),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(invokeSendNotificationCommandV1) && _unref(invokeSendNotificationCommandV1)(...args))),
            class: "btn btn-lg btn-primary pull-right m-1",
            disabled: selectedEmails.value.length==0 || _unref(invokingSendNotificationCommandV1)
          }, "Send", 8 /* PROPS */, _hoisted_9),
          _withDirectives(_createElementVNode("div", _hoisted_10, [
            _cache[7] || (_cache[7] = _createElementVNode("span", null, "Notification was sent successfully", -1 /* CACHED */)),
            _createElementVNode("a", {
              href: `/#/sharing/resource/${resourceProviderName.value}/${resourceId.value}`
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("strong", null, "Close", -1 /* CACHED */)
            ]))], 8 /* PROPS */, _hoisted_11)
          ], 512 /* NEED_PATCH */), [
            [_vShow, _unref(succeedSendNotificationCommandV1)]
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})